export const addSpaceAfterEachWord = (text: string): string => {
  if (!text) return "";
    return text.replace(/([a-zA-Z])(?=[A-Z])/g, "$1 ").trim();
};